module.exports = __webpack_public_path__ + "img/landing_page_3.ff89cf7c.png";